import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "codeField"]

  toggle() {
    if (this.hasCodeFieldTarget) {
      this.codeFieldTarget.classList.toggle("hidden", !this.checkboxTarget.checked)
    }
  }
}
